import { Injectable, inject, signal } from "@angular/core";
import {
  ProviderCreateDTO,
  ProviderGetDTO,
  ProviderUpdateDTO,
} from "src/app/pages/providers/provider.model";
import { environment } from "src/environments/environment";
import { BaseCrudService } from "../generic/base.service";
import { catchError, Observable, of, tap, throwError } from "rxjs";
import { ToastService } from "src/app/shared/services/toast.service";
import { TranslateService } from "@ngx-translate/core";

@Injectable({
  providedIn: "root",
})
export class ProviderService extends BaseCrudService<
  ProviderGetDTO[],
  ProviderCreateDTO,
  ProviderUpdateDTO,
  string
> {
  private baseUrl = environment.baseApiUrl;
  private toast = inject(ToastService);
  private translate = inject(TranslateService);

  providers = signal<ProviderGetDTO[]>([]);

  clearCache(): void {
    this.providers.set([]);
  }

  /** Returns cached providers when available; otherwise loads from API. */
  getCachedOrLoad(): Observable<ProviderGetDTO[]> {
    const cached = this.providers();
    return cached.length > 0 ? of(cached) : this.get();
  }

  constructor() {
    super("/entity/provider"); // ✅
  }

  override get(
    id?: string,
    params?: Record<string, any>,
  ): Observable<ProviderGetDTO[]> {
    return super.get(id, params).pipe(
      tap((response) => {
        this.providers.set(response);
      }),
      catchError((error) => {
        this.toast.error(
          this.translate.instant("toast_errors.getProvidersFailed"),
        );
        console.error("Error fetching providers:", error);
        return throwError(() => error);
      }),
    );
  }
}
